import { Typography as e } from "../../Typography/Typography.mjs";
import { Button as t } from "../Button/Button.mjs";
import { Alert as n } from "../Alert/Alert.mjs";
import { CopyButton as r } from "../Button/CopyButton.mjs";
import { HStack as i, VStack as a } from "../Primitives/Stack.mjs";
import { SecretValue as o } from "./ApiKeySecretPanel.styled.mjs";
import "react";
import { jsx as s, jsxs as c } from "react/jsx-runtime";
//#region src/components/ApiKeySecretPanel/ApiKeySecretPanel.tsx
var l = ({ apiKey: l, warning: u, hint: d, dismissLabel: f, onDismiss: p }) => /* @__PURE__ */ c(a, {
	gap: 2,
	children: [
		/* @__PURE__ */ s(n, {
			variant: "warning",
			children: u
		}),
		/* @__PURE__ */ c(i, {
			gap: 1,
			align: "center",
			children: [/* @__PURE__ */ s(o, { children: l }), /* @__PURE__ */ s(r, { value: l })]
		}),
		/* @__PURE__ */ s(e, {
			variant: "caption",
			color: "secondary",
			children: d
		}),
		p ? /* @__PURE__ */ s(i, { children: /* @__PURE__ */ s(t, {
			variant: "secondary",
			onClick: p,
			children: f
		}) }) : null
	]
});
//#endregion
export { l as ApiKeySecretPanel };
